/* eslint-disable */
import React from "react";
import { Redirect } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AssessmentIcon from "@material-ui/icons/Assessment";
import BudgetReports from "./BudgetReports";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    fontFamily: '"Sarabun", "Tahoma", sans-serif',
    backgroundColor: "#f8fafc",
    minHeight: "100vh"
  },
  titleHeader: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e2e8f0",
    paddingBottom: theme.spacing(2)
  },
  mainTitle: {
    fontWeight: "bold",
    color: "#1e3a8a",
    fontSize: "24px",
    display: "flex",
    alignItems: "center"
  },
  subTitle: {
    color: "#64748b",
    fontSize: "14px",
    marginTop: 4
  }
}));

export default function BudgetReportView() {
  const classes = useStyles();

  const currentUser = (() => {
    try {
      const u = localStorage.getItem("currentUser");
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })();

  const canAccessBudgetReport = (() => {
    if (!currentUser) return false;
    const userDepts = Array.isArray(currentUser.userDepartment)
      ? currentUser.userDepartment
      : Array.isArray(currentUser.userView?.userDepartment)
      ? currentUser.userView.userDepartment
      : [];

    const hasDep110 = userDepts.some(u => Number(u.departmentKey) === 110);
    const hasFinanceDep = userDepts.some(u => {
      const depKey = Number(u.departmentKey);
      return depKey === 102 || depKey === 135 || depKey === 157;
    });

    const isAdmin =
      currentUser?.roles?.includes("Admin") ||
      currentUser?.userName === "madarakung" ||
      userDepts.some(u => Number(u.departmentKey) === 108);

    return hasDep110 || hasFinanceDep || isAdmin;
  })();

  if (!canAccessBudgetReport) {
    return <Redirect to="/finance/slip" />;
  }

  return (
    <div className={classes.root}>
      {/* Top Header */}
      <div className={classes.titleHeader}>
        <div>
          <Typography className={classes.mainTitle}>
            <AssessmentIcon style={{ marginRight: 8, fontSize: 30, color: "#1e3a8a" }} />
            รายงานงบประมาณ
          </Typography>
          <div className={classes.subTitle}>
            รายงานและสถิติข้อมูลการกันเงินและเบิกจ่ายงบประมาณ (สำหรับกลุ่มงานการเงินและกลุ่มงานแผนงาน)
          </div>
        </div>
      </div>

      <BudgetReports />
    </div>
  );
}

